import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bf2df272&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bf2df272&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2df272",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf2df272')) {
      api.createRecord('bf2df272', component.options)
    } else {
      api.reload('bf2df272', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bf2df272&scoped=true", function () {
      api.rerender('bf2df272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerReportManage/index.vue"
export default component.exports